import { render, staticRenderFns } from "./SetReasonModal.vue?vue&type=template&id=0638e059&scoped=true&"
import script from "./SetReasonModal.vue?vue&type=script&lang=js&"
export * from "./SetReasonModal.vue?vue&type=script&lang=js&"
import style0 from "./SetReasonModal.vue?vue&type=style&index=0&id=0638e059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638e059",
  null
  
)

export default component.exports